module.exports = __webpack_public_path__ + "static/img/aff.cc43f92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lender/aff.png
// module id = Zbqs
// module chunks = 1